import React, { Component,useState, useEffect} from 'react';
import L1 from './Im/L1.png'
import google from './Im/google.png'
import './Sign.css';
import { Link, BrowserRouter as Router, Route, Switch, NavLink, Redirect } from "react-router-dom";
import wallet_close from "../Wallet_pg/Im/wallet_close.png";
import axios from "axios";
import firebaseConfig from '../fire';
import Googlelogin from '../Components/Googlelogin.js';
import { firestore } from 'firebase-admin';
import { getAuth } from 'firebase/auth';
import { toast } from 'react-toastify';
import firebase from '@firebase/app-compat';




  const Signup = () => {
   {/*    
    const handleSubmit = (e) => {
      e.preventDefault();    
      let email = document.querySelector("#email").value;
      let password = document.querySelector("#password").value;
      try {
        firebaseConfig.auth().createUserWithEmailAndPassword(email, password);      
        setCurrentUser(true);
      } catch (error) {
        alert(error);
      }
    };
    if (currentUser) {
        return <Redirect to="/profile" />;
    } */}
    /* check if the user is logged in and redirect to home page */
    const checkUser = firebaseConfig.auth().currentUser;
    if (checkUser) {
    window.location.href = "/";
    }
    //const [currentUser, setCurrentUser] = useState(null); 
    const signUrl = "https://us-central1-diginoor-3755e.cloudfunctions.net/app/auth/signup"
    const [ data, setData ] = useState({
        name : "",
        number : "",
        email : "",
        password :"",
      uid:''});
        
    function handleSubmit(e){
    /*  console.log({
        name : data.name,
        email : data.email,
        password : data.password,
        phone : data.number,
      }) */
          e.preventDefault();
          firebaseConfig.auth().createUserWithEmailAndPassword(data.email, data.password)
          
          .then(signupRes => {
            //console.log(signupRes.user.uid)
            data.uid = signupRes.user.uid;
            console.log(data)
            firebaseConfig.firestore().collection('users').add({
              email : data.email,
              name : data.name,
              phone : data.number,
              uid : signupRes.user.uid
            }).then(addToCollection => {
              console.log('document added to users collection')
              

              const actionCodeSettings = {
                          url: 'https://diginoor.io/login?email=' + data.email,
                          handleCodeInApp: true,
                        };
              /* Send Email Verification */
              firebase.auth().currentUser.sendEmailVerification(actionCodeSettings).then(function() {
                firebase.auth().signOut();
                toast.success('Verification Email Sent, Please check your Inbox', {
                  position: toast.POSITION.TOP_CENTER
                  });
                toast.success('Redirecting to Login Page', {
                  position: toast.POSITION.TOP_CENTER
                });
                // set timeout for redirecting to login page
               setTimeout(() => {
                window.location.href = "/login";
               }, 5000); 
              }).catch(function(error) {
                toast.error('Error Sending Verification Email');
              });
            
              
                // const notice = document.getElementById("sign");
                // notice.innerHTML = "Email sent to the address..";
              // }).catch(err => {
              //   console.log('Could not send verification email', err)
              //   alert('Could not send verification email')
              // })
            })
          
          // .catch(error => {
          //   console.log('User signup fail', error)
          //   alert('Something went wrong. Please try again')
          // })
          // fetch(signUrl, 
          //   {body: JSON.stringify({
          //     name : data.name,
          //     email : data.email,
          //     password : data.password,
          //     phone :"+91" + data.number
          //   },
          //     ),
          //     method: "POST",
          //     headers: {
          //       'Content-Type': 'application/json',
          //       'Access-Control-Allow-Origin': '*'}}
          //       )
          //       .then(res => {
          //         console.log(res);
          //         const actionCodeSettings = {
          //           url: 'https://diginoor.io/login',
          //           handleCodeInApp: true,
          //         };

          //         if(res.status == 200){
          //         firebaseConfig.auth().sendSignInLinkToEmail(data.email, actionCodeSettings).then(response_from_email_verify => {
          //           alert('Email to verify sent')
          //           const notice = document.getElementById("sign");
          //           notice.innerHTML = "Successfully Signed Up ! Redirecting to login page..";
          //           setTimeout(window.location.href = '/login', 10000)
                
          //         //console.log(res);
          //       //     const notice = document.getElementById("sign");
          //       //     notice.innerHTML = "Successfully Signed Up ! Redirecting to login page..";
          //       //     setTimeout(window.location.href = '/login', 10000)
          //       // } else {
          //       //   alert('Email address already registered')
          //       // }
          //         }).catch(err => {
          //           alert('Could not send verification email')
          //         })
          //       }
                 
          //       })
          //       .catch(err =>{ //console.log(err);
          //         alert('Please check your email id')});
        })
        // handle error
        .catch(error => {
          console.log('User signup fail', error)
          alert('Something went wrong. Please try again')
        });



        }
    function handleChange(e){
      const newdata = {...data};
      newdata[e.target.id] = e.target.value;
      setData(newdata);
    }
    


    return (
    <div className="signin-all">
  <div className="raj-block rajini-mobile">
    <img className="raji" src={L1} alt="Logo" />;
</div>

    <div className="signin">

    <div><Link to="/"><img className="close-signup" src={wallet_close} alt="Logo" /></Link></div>
    <Googlelogin />

      <br></br><br></br><br></br>
      <div>
          <div className="sign-hr1">

          </div>

           <div className="sign-hr2">

             </div>
             <div>
               <p className="or-sign">Or</p>
             </div>
      </div>
      
      <form onSubmit={(e) => handleSubmit(e) } className="form-sign" >
      <label className="lab-sign">Name</label>
        <br></br>
        <input  className="textbox" onChange = {(e) => handleChange(e) } id="name" value={data.name} type="text" placeholder="Your Name" name="name" ></input>
        <br></br>
        <label className="lab-sign">Phone</label>
        <br></br>
        <div>
    </div> 
        <input className="textbox" onChange = {(e) => handleChange(e) } id="number" value={data.number} type="text" placeholder="Phone Number with country code" name="number" ></input><br></br>
        <label className="lab-sign">Email</label>
        <br></br>
        <input  className="textbox" onChange = {(e) => handleChange(e) } id="email" value={data.email} type="email" placeholder="Your Email id" name="email" ></input>
        <br></br>
        <label className="lab-sign">Password</label>
        <br></br>
        <input className="textbox" onChange = {(e) => handleChange(e) } id="password" value={data.password} type="password" placeholder="min 9 characters"></input>
        <label className="lab-sign">Confirm Password</label>
        <br></br>
        <input className="textbox" type="password" placeholder="min 9 characters" name="password" ></input> 
      <Link to ="/login"><p className="already-acc">Already have an account? Sign in</p></Link>
      <button type="submit"  className="bn632-hover bn21">SIGN UP</button>
      <div className="reg-notice">
        <p id="sign"></p>
      </div>
      </form>

    </div>
  </div>
    );
  }

export default Signup;